import { Component, Input } from '@angular/core';
import { System } from '@app/core/resources/system';

@Component({
    selector: 'app-networks-system',
    templateUrl: './networks-system.component.html',
    styleUrls: ['./networks-system.component.scss']
})
export class NetworksSystemComponent {
    @Input() public system: System = new System();
}
